export const FEED_PLACEMENT = {
  LIGHT: "Feed Below Article",
  DARK: "Feed Below Article Dark",
};
